import { useTranslation } from 'react-i18next';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Card from 'react-bootstrap/Card';
import Button from 'react-bootstrap/Button';
import { Helmet } from 'react-helmet';

import { useNavigate } from "react-router-dom";
import { renderToStaticMarkup } from 'react-dom/server';

import ReactGA from 'react-ga4';
import '../../static/css/tilesets.css';

import general from '../../static/json/general.json';


function Minigame({game, type}) {

	const navigate = useNavigate();
	const { t } = useTranslation();

	var detectedLanguage = window.location.pathname.split('/')[1];
    if(detectedLanguage == "" || detectedLanguage.length > 2) {
    	detectedLanguage = "en";
    }

	function playGame({game}) {
	    ReactGA.event({
	        category: 'Game',
	        action: 'StartGame'
	    });
    }

    function textToUpper({game}) {
        if(game == "same") {
            return "SAME GAME";
        }
        return game.toUpperCase();
	}

	function getHref({detectedLanguage, game}) {
		if(type == "out") {
			if(game == "spellbee") {
				return "https://www.spell-bee.com/index.html?utm_source=Tiles";
			}
			if(game == "strands") {
				return "https://www.strands-wordle.com/?utm_source=Tiles";
			}
		}

		if(game === "tiles") {
			if(detectedLanguage === "en") {
				return "/";
			} else {
				return detectedLanguage;
			}
		}
		return "/" + detectedLanguage + "/" + game;
	}

    return (
        <Col className='tilesetContainer'>
            <Card className='tilesetCard'>
                 {
                    type == "in" ? <Card.Img variant="top" src={"/images/games/" + game + "/default.png"}  />
                    : <Card.Img variant="top" src={"/images/moregames/" + game + ".png"}  />
                 }

                <Card.Body>
                    <Card.Title>{textToUpper({game})}</Card.Title>
                    <Card.Text>{""}</Card.Text>
                    <Button href={getHref({detectedLanguage, game})} className="small-btn" variant="primary" onClick={() => playGame({game})}>{t("play")}</Button>

                </Card.Body>
            </Card>
        </Col>
    );
}




const Minigames = () => {
	const { t } = useTranslation();
	const games = ["lines", "same", "tiles", "pairs", "infinite"];
	const moregames = [
		{"name": "spellbee", "title": ""},
		{"name": "strands", "title": "" }
	];


	const gamesHtml =  (

		<Container>
	        <h2>{ t("otherGames") }</h2>
	        <p className="intro">{ t("otherGamesDescription") }</p>
	        {
	            <Row>
	                {games.map(game => ( <Minigame game={game} key={game} type="in"/>))}
	                {moregames.map(game => ( <Minigame game={game["name"]} key={game} type="out"/>))}

	            </Row>
	        }
	    </Container>
    );

    return gamesHtml;
}
export default Minigames;
